import {isEmpty} from 'lodash';
import constants from '../../core/constants';
import {incidentViewport} from 'Services/services/incidentViewport';

const MINIMUM_INTERVAL = 30000;
const TRAFFIC_MODEL_ID_EXPIRATION_TIME = 115000; // 1:55m

class IncidentViewportPeriodicUpdater {
    constructor() {
        this._trafficModelId = constants.VIEWPORT_DEFAULT_VALUE;
        this._trafficModelIdTimestamp = null;
        this._intervalInMillis = null;
        this._trafficViewportApiKey = null;
        this._onModelIdRetrievedCallbacks = {};
        this._intervalId = null;
        this._trafficModelIdRetrievalStarted = false;
        this._trafficModelIdExpiration = TRAFFIC_MODEL_ID_EXPIRATION_TIME;

        this._trafficModelIdPropagator = async () => {
            if (this._trafficModelIdRetrievalStarted) {
                return;
            }

            this._trafficModelIdRetrievalStarted = true;
            const trafficViewportResponse = await incidentViewport({
                key: this._trafficViewportApiKey
            }).go();
            this._trafficModelId = trafficViewportResponse.getTrafficModelId();
            this._trafficModelIdTimestamp = Date.now();
            Object.keys(this._onModelIdRetrievedCallbacks).forEach((callbackName) => {
                this._onModelIdRetrievedCallbacks[callbackName](this._trafficModelId);
            });
            this._trafficModelIdRetrievalStarted = false;
        };
    }

    set = (intervalInMillis, trafficViewportApiKey) => {
        this._intervalInMillis = intervalInMillis < MINIMUM_INTERVAL ? MINIMUM_INTERVAL : intervalInMillis;
        this._trafficViewportApiKey = trafficViewportApiKey;

        if (this._intervalId) {
            clearInterval(this._intervalId);
        }

        this._intervalId = setInterval(this._trafficModelIdPropagator, this._intervalInMillis);
    };

    resetTimers = () => {
        clearInterval(this._intervalId);
        this._intervalId = setInterval(this._trafficModelIdPropagator, this._intervalInMillis);
    }

    addOnModelIdRetrievedCallback = (callbackName, callback) => {
        this._onModelIdRetrievedCallbacks[callbackName] = callback;
        if (this._trafficModelId !== constants.VIEWPORT_DEFAULT_VALUE) {
            callback(this._trafficModelId);
        } else {
            this._trafficModelIdPropagator();
        }
    };

    refreshTrafficModelIdAndExecuteCallbacks = (callbackName) => {
        const currentTimestamp = Date.now();
        const isTrafficModelIdExpired =
            currentTimestamp - this._trafficModelIdTimestamp > this._trafficModelIdExpiration;

        if (isTrafficModelIdExpired) {
            this._trafficModelIdPropagator();
            this.resetTimers();
        } else if (callbackName) {
            this._onModelIdRetrievedCallbacks[callbackName](this._trafficModelId);
        }
    }

    removeOnModelIdRetrievedCallback = (callbackName) => {
        delete this._onModelIdRetrievedCallbacks[callbackName];
        if (isEmpty(this._onModelIdRetrievedCallbacks) && this._intervalId) {
            clearInterval(this._intervalId);
            this._intervalId = null;
            this._trafficModelId = constants.VIEWPORT_DEFAULT_VALUE;
        }
    }
}

export default new IncidentViewportPeriodicUpdater();



// WEBPACK FOOTER //
// ./map/tier/incidentViewportPeriodicUpdater.js